const softwareActivationModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl:
    '/modules/modals/software-activation-modal/software-activation-modal.html',
  controller: 'SoftwareActivationModalController',
};

angular
  .module('modalDirectives')
  .component('softwareActivationModal', softwareActivationModal);
